import { render, staticRenderFns } from "./StockOpnameTabs.vue?vue&type=template&id=55d5d67f&scoped=true"
import script from "./StockOpnameTabs.vue?vue&type=script&lang=js"
export * from "./StockOpnameTabs.vue?vue&type=script&lang=js"
import style0 from "./StockOpnameTabs.vue?vue&type=style&index=0&id=55d5d67f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d5d67f",
  null
  
)

export default component.exports